export default __webpack_public_path__ + "static/media/groupIcon.c5466a63.svg";